import { push } from 'connected-react-router';
import { AnyObject } from 'final-form';
import { takeEvery, fork, put, call } from 'redux-saga/effects';
import { Reducer, Action } from 'redux';
import SecondWindowService from 'src/service/SecondWindowService';

export interface INavigationState {
    formState: AnyObject;
}

const initalState: INavigationState = {
    formState: undefined,
};

export enum actionTypes {
    NAVIGATE = '[navigate] NAVIGATE',
    PUSH_FORM = '[navigate] PUSH_FORM',
    UPDATE_FORM = '[navigate] UPDATE_FORM',
}

export const actionCreators = {
    navigate: (payload: { path: string; state?: AnyObject }) => {
        return { type: actionTypes.NAVIGATE, payload };
    },
    updateForm: (payload: AnyObject) => {
        return { type: actionTypes.UPDATE_FORM, payload };
    },
    pushForm: (payload: AnyObject) => {
        return { type: actionTypes.PUSH_FORM, payload };
    },
};

const reducer: Reducer<INavigationState> = (state: INavigationState = initalState, action: Action) => {
    // console.log('action', action);
    switch (action.type) {
        case actionTypes.UPDATE_FORM:
            const payload = (action as { type: string; payload: AnyObject }).payload;
            return {
                ...state,
                formState: payload,
            };
        default:
            return state;
    }
};

export default reducer;

const sagas = {
    navigate: function* (action: { type: string; payload: { path: string; state?: AnyObject } }) {
        yield put(push(action.payload.path, action.payload.state));
    },
    pushForm: function* (action: { type: string; payload: AnyObject }) {
        // console.log('pf', action.payload);
        yield call(SecondWindowService.sendMessage, `${process.env.REACT_APP_TITLE} Superview`, 'pushform', action.payload);
    },
};

const watches = {
    watchNavigate: function* () {
        yield takeEvery(actionTypes.NAVIGATE, sagas.navigate);
    },
    watchPushForm: function* () {
        yield takeEvery(actionTypes.PUSH_FORM, sagas.pushForm);
    },
};

export function* saga() {
    yield fork(watches.watchNavigate);
    yield fork(watches.watchPushForm);
}



// WEBPACK FOOTER //
// ./src/reducers/Navigation.ts